/**
 * UI Components Type Definitions
 * v13 Section 4.5.1 - Mission Card Types
 */
/**
 * Card dimensions lookup table
 */
export const CARD_DIMENSIONS = {
    shopping: { type: 'shopping', height: 290, hasImage: true, hasBrandLogo: true, hasPrice: true },
    savings: { type: 'savings', height: 284, hasImage: true, hasBrandLogo: true, hasPrice: false },
    consumables: { type: 'consumables', height: 284, hasImage: true, hasBrandLogo: false, hasPrice: false },
    content: { type: 'content', height: 284, hasImage: true, hasBrandLogo: true, hasPrice: false },
    travel: { type: 'travel', height: 208, hasImage: true, hasBrandLogo: false, hasPrice: false },
    entertainment: { type: 'entertainment', height: 207, hasImage: true, hasBrandLogo: false, hasPrice: false },
    food: { type: 'food', height: 287, hasImage: true, hasBrandLogo: false, hasPrice: false },
    people: { type: 'people', height: 210, hasImage: true, hasBrandLogo: false, hasPrice: false },
    health: { type: 'health', height: 180, hasImage: true, hasBrandLogo: false, hasPrice: false },
};
/**
 * Breakpoint configuration for masonry layout
 */
export const BREAKPOINT_COLUMNS = {
    default: 4, // 1920px+
    1440: 4,
    1280: 3,
    1024: 3,
    768: 2,
    640: 2,
};
export const FILTER_TABS = [
    { id: 'all', label: 'All' },
    { id: 'savings', label: 'Savings' },
    { id: 'ikigai', label: 'Ikigai' },
    { id: 'health', label: 'Health' },
];
